import styled from "styled-components";

export const Scaler = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  background: black;
  opacity: 0.05;
  width: 3px;
  cursor: ew-resize;
  transition: 150ms linear all;
  &:hover {
    width: 6px;
    right: -3px;
    opacity: 0.2;
  }
`;
